/**
 * @voltxampere/ui — LED (Light-Emitting Diode) · semantic brass
 *
 * Zenit §9.2 carves out a single semantic exception: the LED uses
 * BRASS strokes everywhere (not IVORY) and a semi-transparent
 * BRASS-HOT body fill, plus two BRASS-HOT light-emission rays. The
 * canonical light-ray strokes ship at width 1.1 (below the §9.1
 * range); they are clamped to 1.3 here so the symbol passes the
 * stroke-discipline gate without losing the visual nuance of "thinner
 * than the body".
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { FILL_LED, STROKE_BRASS, STROKE_BRASS_HOT, STROKE_WIDTH_DETAIL, STROKE_WIDTH_MAIN, VIEWBOX_DEFAULT, } from "./constants.js";
export const led = {
    id: "led",
    nameTr: "LED",
    nameEn: "LED",
    shortcut: "7",
    category: "active",
    viewBox: VIEWBOX_DEFAULT,
    terminals: [
        { x: 0, y: 13, label: "A", polarity: "in" },
        { x: 40, y: 13, label: "K", polarity: "out" },
    ],
    defaultLabel: "D",
    renderSVG: () => [
        `<line x1="0" y1="13" x2="13" y2="13" stroke="${STROKE_BRASS}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<polygon points="13,6 24,13 13,20" fill="${FILL_LED}" stroke="${STROKE_BRASS}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="24" y1="6" x2="24" y2="20" stroke="${STROKE_BRASS}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="24" y1="13" x2="40" y2="13" stroke="${STROKE_BRASS}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="28" y1="4" x2="33" y2="0" stroke="${STROKE_BRASS_HOT}" stroke-width="${String(STROKE_WIDTH_DETAIL)}"/>`,
        `<polygon points="31,1 33,0 32,3" fill="${STROKE_BRASS_HOT}"/>`,
        `<line x1="32" y1="6" x2="37" y2="2" stroke="${STROKE_BRASS_HOT}" stroke-width="${String(STROKE_WIDTH_DETAIL)}"/>`,
        `<polygon points="35,3 37,2 36,5" fill="${STROKE_BRASS_HOT}"/>`,
    ].join(""),
};
//# sourceMappingURL=led.js.map